import React, { useRef, useState } from 'react';
import { Container, Typography, Box, Grid, TextField, Button, Alert, Checkbox, FormControlLabel, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import emailjs from 'emailjs-com';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import pdf from '../assets/files/politica_de_confidentialitate_protectiadatelor.pdf';

// Styled Components
const ContactSection = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '3em 0',
});

const FormContainer = styled(Box)({
  marginTop: '20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '1em',
  padding: '20px',
  background: 'white',
  borderRadius: '10px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
});

const SubmitButton = styled(Button)({
  backgroundColor: '#4D8F55',
  color: 'white',
  padding: '10px 20px',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#3B6E40',
  },
});

const ContactInfo = styled(Box)({
  marginTop: '20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5em',
  padding: '20px',
  background: 'white',
  borderRadius: '10px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
});

const InfoItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5em',
  color: '#4D8F55',
  cursor: 'pointer',
});

const Contact = () => {
  const form = useRef();
  const [alert, setAlert] = useState({ message: '', severity: '' });
  const [isChecked, setIsChecked] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_4s8bl28', 'template_rwtuv7q', form.current, 'c1cNtfZbeJNy--WLO')
      .then(
        (result) => {
          setAlert({ message: 'Mesajul a fost trimis cu succes!', severity: 'success' });
          e.target.reset();
        },
        (error) => {
          setAlert({ message: 'Eroare la trimiterea mesajului, vă rugăm să încercați din nou.', severity: 'error' });
        }
      );
  };

  return (
    <Container>
      <ContactSection>
        <Grid container spacing={4}>
          {/* Left Side - Text and Contact Information */}
          <Grid item xs={12} md={5}>
            <Typography variant="h5" gutterBottom color="#4D8F55" sx={{ fontWeight: 'bold' }}>
              Contact
            </Typography>
            <Typography variant="body1" paragraph>
              Contactează-ne prin formularul de contact alăturat sau prin adresa de email notată mai jos.
            </Typography>
            <Typography variant="body2" color="#4D8F55">
              Câmpurile evidențiate cu * sunt obligatorii!
            </Typography>

            <Typography variant="h5" gutterBottom color="#4D8F55" sx={{ marginTop: '20px', fontWeight: 'bold' }}>
              Date de contact
            </Typography>
            <ContactInfo>
              <InfoItem>
                <PhoneIcon sx={{ fontSize: '1.5rem' }} />
                <Typography variant="body1">
                  <a href="tel:0724526752" style={{ color: '#4D8F55', textDecoration: 'none' }}>
                    0724526752
                  </a>
                </Typography>
              </InfoItem>
              <InfoItem>
                <EmailIcon sx={{ fontSize: '1.5rem' }} />
                <Typography variant="body1">
                  <a href="mailto:info@datacert.ro" style={{ color: '#4D8F55', textDecoration: 'none' }}>
                  info@datacert.ro
                  </a>
                </Typography>
              </InfoItem>
              <InfoItem>
                <LocationOnIcon sx={{ fontSize: '1.5rem' }} />
                <Typography variant="body1">
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=Constantin+Sandu+Aldea+24+Sector+1"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#4D8F55', textDecoration: 'none' }}
                  >
                    Constantin Sandu Aldea 24, et. 4, Sector 1
                  </a>
                </Typography>
              </InfoItem>
            </ContactInfo>
          </Grid>

          {/* Right Side - Form */}
          <Grid item xs={12} md={7}>
            {alert.message && (
              <Alert severity={alert.severity} sx={{ marginBottom: '1em' }}>
                {alert.message}
              </Alert>
            )}
            <FormContainer component="form" ref={form} onSubmit={sendEmail}>
              <TextField
                required
                label="Nume"
                name="user_name"
                fullWidth
                variant="outlined"
                color="success"
              />
              <TextField
                required
                label="Adresa de email"
                name="user_email"
                type="email"
                fullWidth
                variant="outlined"
                color="success"
              />
              <TextField
                required
                label="Numar de telefon"
                name="user_phone"
                fullWidth
                variant="outlined"
                color="success"
              />
              <TextField
                required
                label="Mesaj"
                name="message"
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                color="success"
              />
              <FormControlLabel
                control={<Checkbox checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)} color="success" />}
                label="Sunt de acord ca email-ul meu să fie colectat pentru a primi datele solicitate."
              />
              <Typography variant="body2" color="textSecondary" sx={{ marginTop: '0.5em' }}>
                Pentru mai multe informații privind prelucrarea datelor, puteți accesa politica de confidențialitate{' '}
                <Link href={pdf} target="_blank" rel="noopener noreferrer" sx={{ color: '#4D8F55', textDecoration: 'none' }}>
                  aici
                </Link>.
              </Typography>
              <SubmitButton type="submit" variant="contained" disabled={!isChecked}>
                Trimite cererea
              </SubmitButton>
            </FormContainer>
          </Grid>
        </Grid>
      </ContactSection>
    </Container>
  );
};

export default Contact;
